import { Layout3DProject } from './layout3dGenerate';
import { LAYOUT_3D_CACHE_PREFIX, LAYOUT_3D_JSON_VERSION } from './layout3dConstants';

export function loadLayout3DFromCache(boundsKey: string): Layout3DProject | null {
  try {
    const raw = localStorage.getItem(LAYOUT_3D_CACHE_PREFIX + boundsKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Layout3DProject;
    if (!parsed?.elements || !parsed?.elementOrder?.length) return null;
    if (parsed.version !== LAYOUT_3D_JSON_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveLayout3DToCache(project: Layout3DProject): boolean {
  try {
    localStorage.setItem(LAYOUT_3D_CACHE_PREFIX + project.boundsKey, JSON.stringify(project));
    return true;
  } catch {
    return false;
  }
}

export function downloadLayout3DJson(project: Layout3DProject, filename?: string): void {
  const blob = new Blob([JSON.stringify(project, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? `layout-3d-${project.boundsKey}-${project.objectCount}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
